import AuthArrow from "./AuthArrow";
import AuthArrow2 from "./AuthArrow2";
import AuthLock from "./AuthLock";
import EditIcon from "./EditIcon";
import GoogleIcon from "./GoogleIcon";
import LogoText from "./LogoText";
import MessageIcon from "./MessageIcon";
import MessageIconDark from "./MessageIconDark";
import PasswordIcon from "./PasswordIcon";
import ResendIcon from "./ResendIcon";
import SuccessIcon from "./SuccessIcon";
import MobileIcon from "./MobileIcon";
import MobileIconDark from "./MobileIconDark";
const AuthIcons = {
  AuthArrow,
  
  AuthArrow2,
  AuthLock,
  EditIcon,
  GoogleIcon,
  LogoText,
  MessageIcon,
  MessageIconDark,
  PasswordIcon,
  ResendIcon,
  SuccessIcon,
  MobileIconDark,

  MobileIcon,
};

export default AuthIcons;
